<template>
  <div class="pc-search">
    <el-form class="pc-search-main-form" :model="keywords" :inline="true">
      <div class="line-one">
        <el-form-item label="城市群名称" class="short-select">
          <el-input
            v-model="keywords.name"
            maxlength="60"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签" class="short-select">
          <el-cascader
            :options="options"
            v-model="keywords.keywords"
            clearable
            placeholder="选择标签"
          ></el-cascader>
        </el-form-item>
      </div>
      <div class="line-two">
        <el-form-item label="大洲" class="short-select">
          <el-select v-model="keywords.continent" placeholder="请选择大洲" clearable @change='getCountryDicList()'>
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in continentList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" class="short-select">
          <el-select v-model="keywords.country" placeholder="请选择国家"  clearable :disabled='keywords.continent==null'>
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in countryList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <button class="pc-search-clickBtn" @click.prevent="search">筛选</button>
    </el-form>
  </div>
</template>

<script>
import { getTagTypes,getDictionaries } from "./regionList.gql";
export default {
  data() {
    return {
      options: [],
      typeTagArgs: {
        skip: 0,
        type: "REGION",
        order: "+createTime",
      },
      keywords: {
        name: null,
        keywords: null,
        country: null,
        continent: null,
      },
      continentList: [],
      countryList: [],
    };
  },
  async created() {
    this.getContinentDicList("map_position");
    this.getTagTypes();
  },
  methods: {
    getTagTypes() {

      this.$global
        .GraphqlQuery(this, getTagTypes, this.typeTagArgs)
        .then((res) => {
          console.log(res);
          this.options = [];
          for (let i = 0; res.data.length > i; i++) {
            this.options.push(res.data[i]);
            this.options[i].value = this.options[i].name;
            this.options[i].label = this.options[i].name;
            if (res.data[i].tags.length > 0) {
              this.options[i].children = res.data[i].tags;
              for (let t = 0; res.data[i].children.length > t; t++) {
                this.options[i].children[t].label =
                  this.options[i].children[t].name;
                this.options[i].children[t].value =
                  this.options[i].children[t].name;
              }
            }
          }
          console.log(this.options);
        });
    },
    getContinentDicList(type) {
      this.$global
        .GraphqlQuery(this, getDictionaries, { type: type })
        .then((res) => {
          this.continentList = res.data;
          console.log(this.continentList);
        });
    },
    getCountryDicList(a) {
      console.dir(a);
      console.log(123);
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: ("map_position_" + this.keywords.continent)
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.countryList = res.data;
        });
    },

    search() {
      this.$emit("search", this.keywords);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-search-main-form {
  position: relative;
  .line-one,
  .line-two {
    width: 90%;
  }

  /deep/ .el-input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .el-form-item__label {
    font-family: $chinese;
    font-size: 16px;
    font-weight: bold;
    color: $mainTitle;
    width: 100px;
    margin-right: 40px;
  }

  /deep/ .long-select {
    width: 853px;
    .el-form-item__content {
      width: 710px;
      .el-input__inner {
        width: 100%;
      }
    }
  }
  /deep/ .short-select .el-input__inner {
    width: 280px;
  }
  .pc-search-clickBtn {
    position: absolute;
    right: 0px;
    bottom: 20px;
    width: 90px;
    height: 40px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/regionList/Search.vue